import React from 'react';
import './technologyCard.css'

function C2wTechnolgyCard( { obj } ) {
  return (
    <div className='C2wTeachnologyCard_div'>
      <div className='C2wTeachnologyCard'>
          <img src={`/assets/images/landing/${obj?.imageName}.svg`} />
      </div>
        <span>{obj?.title}</span>
    </div>
  )
}

export default C2wTechnolgyCard;
